var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHairBack = function SvgHairBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 35,
    height: 39,
    viewBox: "0 0 1.17 1.31",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.21.66S.16.83.06.88C.01.91.02 1.05.19 1c-.24.16.1.22.12.15 0 .12.18.19.25.05.01-.02.03.06.12.05.09 0 .12-.13.12-.14.03.05.17.11.18-.01 0-.18.03.02.13-.09C1.2.92 1.05.86 1 .82.92.76.98.73.93.72c-.09.21-.36.41-.47.35C.34.99.27.83.21.66z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.07,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.67.11C.32 0 .08.3.21.66c.06.17.13.33.25.41.13.08.49-.23.49-.47C.95.35.89.17.67.11z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })));
};

export default SvgHairBack;